import React from 'react'
import Panel from './Panel'
import { List, Tooltip, IconButton } from '@material-ui/core'
import PersonAdd from '@material-ui/icons/PersonAdd'
import { isNil, isEmpty } from 'ramda'
import PersonAvatar from './PersonAvatar'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import * as R from 'ramda'

const ProfilePicturePanel = (props) => {
  const {
    title,
    items,
    emptyContent,
    onItemClick,
    link,
    withCrmField,
    subscribersPageSection,
    teamMembersPageSection,
  } = props
  return subscribersPageSection || teamMembersPageSection ? (
    <List className="py-8 flex flex-wrap items-start justify-start text-start">
      {isEmpty(items)
        ? emptyContent
        : items.map((item) => (
            <div key={item.id}>
              <Tooltip
                className="p-4"
                title={isNil(item.name) ? '' : item.name}
                disableHoverListener={isNil(item.name)}
              >
                <IconButton
                  onClick={!isNil(onItemClick) ? () => onItemClick(item) : null}
                >
                  <PersonAvatar
                    placeHolder={item && item.avatarCharacters}
                    subId={item.id}
                    src={
                      withCrmField
                        ? R.path(['crmInfo', 'avatar'], item)
                        : item.avatar
                    }
                    alt={item.name}
                  />
                </IconButton>
              </Tooltip>
            </div>
          ))}
    </List>
  ) : (
    <Panel
      startText={title}
      endView={
        <Link to={link}>
          <IconButton color="secondary">
            <PersonAdd />
          </IconButton>
        </Link>
      }
    >
      <List className="p-0 flex flex-wrap items-start justify-start text-start">
        {isEmpty(items)
          ? emptyContent
          : items.map((item) => (
              <div className="w-1/4" key={item.id}>
                <Tooltip
                  className="p-4"
                  title={isNil(item.name) ? '' : item.name}
                  disableHoverListener={isNil(item.name)}
                >
                  <IconButton
                    onClick={
                      !isNil(onItemClick) ? () => onItemClick(item) : null
                    }
                  >
                    <PersonAvatar
                      placeHolder={item && item.avatarCharacters}
                      subId={item.id}
                      src={
                        withCrmField
                          ? R.path(['crmInfo', 'avatar'], item)
                          : item.avatar
                      }
                      alt={item.name}
                    />
                  </IconButton>
                </Tooltip>
              </div>
            ))}
      </List>
    </Panel>
  )
}

ProfilePicturePanel.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
  ]),
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      name: PropTypes.string,
      avatar: PropTypes.string,
    }),
  ),
  remainingCount: PropTypes.number,
  emptyContent: PropTypes.element,
  onItemClick: PropTypes.func,
}

export default ProfilePicturePanel
